export default "__VITE_ASSET__B7j1Qpuj__"